import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [] } = whatsAppData || {};
  const { user } = useContext(AuthContext);

  const [callConfig, setCallConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.id) return;
    api.get("/call/config")
      .then(({ data }) => setCallConfig(data))
      .catch(() => setCallConfig(null));
  }, [user?.id]);

  if (error) {
    console.warn("WhatsAppsProvider error:", error);
  }

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, error }}>
      {children}

      {/* Widget de ligação desativado no CRM (desktop) de propósito — decisão
          do usuário em 2026-08-07: a ligação já funciona de ponta a ponta no
          app Visita (mobile), que é onde precisa mesmo. Não reativar aqui
          sem pedido explícito. */}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };
